// Canonical property-type buckets used in search filters.
// We map raw provider strings (RentCast / ATTOM / synthetic) into these buckets.

export const PROPERTY_TYPES = [
  { id: "single_family", label: "Single Family" },
  { id: "multi_family", label: "Multi-Family" },
  { id: "condo_townhouse", label: "Condo / Townhouse" },
  { id: "manufactured", label: "Manufactured / Mobile" },
  { id: "land", label: "Land / Lot" },
  { id: "commercial", label: "Commercial" },
];

const RULES = [
  { id: "land", needles: ["land", "lot", "vacant"] },
  { id: "manufactured", needles: ["manufactured", "mobile"] },
  { id: "commercial", needles: ["commercial", "industrial", "office", "retail"] },
  { id: "condo_townhouse", needles: ["condo", "townhouse", "townhome"] },
  { id: "multi_family", needles: ["multi", "duplex", "triplex", "fourplex", "apartment", "small multi"] },
  { id: "single_family", needles: ["single family", "sfr", "single-family"] },
];

export function bucketOfType(raw) {
  if (!raw) return "single_family"; // safest fallback for wholesale data
  const s = String(raw).toLowerCase().trim();
  for (const r of RULES) {
    if (r.needles.some((n) => s.includes(n))) return r.id;
  }
  return "single_family";
}

export function filterByTypes(properties, selectedIds) {
  if (!selectedIds || selectedIds.length === 0) return properties;
  const set = new Set(selectedIds);
  return properties.filter((p) => set.has(bucketOfType(p.property_type)));
}
